<template>
  <footer>
    <div class="footer-info">
        <b-container fluid>
            <div class="footer-logo">
                <router-link :to="{name: 'homepage'}">
                    <img :src="require('/public/assets/logo-footer.svg')" />
                </router-link>
            </div>
            <div class="links">
                <br/><br/>
                <div class="panel-gray">
                <b-container fluid>
                    <b-row class="linkList">

                        <b-col sm="12" md="4" lg="4">
                            <div class="footerBlock">
                            <p class="linkTitle">
                                Chi siamo
                            </p>
                              <router-link :to="{name: 'about'}">Agenzia Viaggi by Vivamod di Salabam Solutions</router-link>
                              <a href="https://www.salabamsolutions.com" target="_blank">Salabam Solutions</a>
                              <router-link :to="{name: 'contacts'}">Contatti</router-link>
                              <!--<router-link :to="{name: 'faq'}">Domande frequenti</router-link>-->
                            </div>
                        </b-col>

                        <b-col sm="12" md="4" lg="4">
                            <div class="footerBlock">
                              <p class="linkTitle">
                                  Legal
                              </p>
                              <router-link :to="{name: 'terms'}">Termini e condizioni</router-link>
                              <a :href="site.urlPrivacy" target="_blank">Privacy Policy</a>
                              <a :href="site.urlCookiePolicy" target="_blank">Cookie Policy</a>
                            </div>
                        </b-col>

                        <!--<b-col sm="12" md="4" lg="4">
                            <div class="footerBlock">
                            <p class="linkTitle">
                                Footer Links
                            </p>
                            <router-link :to="{name: 'homepage'}">Link 1</router-link>
                            </div>
                        </b-col>-->

                    </b-row>
                </b-container>
                </div>
            </div>
            <div class="footer-bottom">
                <a href="#">© SALABAM SRL - P.IVA: 04238550406</a>
                <a href="http://www.taiview.com" target="_blank">Ui & Ux Design: taiview.com</a>
            </div>
        </b-container>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'page-footer',
  components:
    {
    },
  props: {
    footerMenu: String,
    btnText: String,
  },
    created()
    {
    },
  data (){
    return {
      site: this.$config.site,
    }
  },
  computed: {
  },
}
</script>


<style lang="scss">





footer
{
  .footer-info
  {
    position:relative;
    overflow:hidden;
    .poweredBy
    {
      left:50%;
      right:auto;
      top:0;
      transform-origin: top center;;
      transform:translateX(-50%) scale(0.75);
      margin:0 auto;
      position:absolute;
      //background:$light-gray;
    }
  }

}

.footer-info
{
  text-align:center;
  padding-top:90px;
  padding-bottom:60px;
  background:$tertiary;
  color:$white;

  .footer-menu a
  {
    //@include dynamic-colors-blend();
    //@include theme-text-footer();
    color:$white;
  }
}

.footer-logo
{
  display:flex;
  justify-content:center;
  img
  {
    max-width: 220px;
    margin:1rem auto;
  }
}

.footer-menu
{
  display:flex;
  flex-direction: column;
  margin:50px auto;
  justify-content: center;
  li
  {
    &:not(last-child)
    {
      //border-right:1px solid $black;
    }
  }

  a
  {
    //@include customize-color("white");
    //@include dynamic-colors-blend();
    color:$white;
  }
}

.footer-bottom
{
  display:flex;
  flex-direction: column;
  font-size:14px;
  padding-top:70px;
  padding-bottom:70px;
  & > *:not(:last-child)
  {
    margin-bottom:20px;
  }
  a
  {
    color:$white;
  }
  svg
  {
    margin:0 10px;
    path
    {
      //@include customize-fill("white");
      //@extend [custom-fill-light] !optional;
    }
  }
}

@include media-breakpoint-up(lg)
{
  .footer-menu
  {
    display:flex;
    flex-direction: row;
    margin:50px 0 100px 0;
    li
    {
      &:not(:last-child) a
      {
        margin-right:20px;
        padding-right:20px;
        border-right:1px solid;
      }
    }
  }

  .footer-bottom
  {
    flex-direction:row;
    justify-content:space-between;
    & > *:not(:last-child)
    {
      margin-bottom:0;
    }
    & > *
    {
      flex:33%;
      width:33%;
      text-align:center;
    }
  }
}

.btn-to-top {
  width: 60px;
  height: 60px;
  padding: 10px 16px;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
}

.vue-back-to-top
{
  z-index:10 !important;
  .svg
  {
    //@include dynamic-colors-blend();
  }
}

.links
{

  text-align: left;

  .linkTitle, .linkTitle a
  {
    color:$white;
    font-size: 16px!important;
    font-weight: 600;
    margin-bottom:1rem!important;
  }
  .linkList a
  {
    color:$white;
    font-size: 13px;
    font-weight: 600;
    display:block;
    margin-bottom:0.5rem;
  }

  .col-lg-4
  {
    display: flex;
    justify-content: center;
  }
}

</style>